import React, { useEffect } from 'react';
import './App.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, login, logout } from './features/userSlice';
import { auth } from './firebase';
import Feed from './components/Feed';
import Auth from './components/Auth';
import styles from './App.module.css';

const App: React.FC = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {

    //firebaseでユーザーの情報に何らかの変化(ログイン、ログアウト)があったときに更新される関数
    const unSub = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        dispatch(
          login({
          uid: authUser.uid,
          photoUrl: authUser.photoURL,
          displayName: authUser.displayName,
        })
        );
      } else {
        dispatch(logout());
      }
    });

    return () => {
      unSub();
    }
  }, [dispatch]);

  return (
    <>
    <div className={styles.wrapper}>
     {user.uid ? (
       <div className={styles.app}>
       <Feed />
       </div>
     ) : (
       <Auth />
     )}
    </div>
    </>
  );
}

export default App;
